import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Table, TableBody, TableRow, TableCell, IconButton, Tooltip, Chip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { setCurrentPayoff } from 'redux/actions/Finance';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { toPersianDate, toPersianMoneyForamt } from '@jumbo/utils/dateHelper';

const stateMap = {
  approved: { label: 'موفق', color: 'primary' },
  pending: { label: 'در حال بررسی', color: '' },
  canceled: { label: 'ناموفق', color: 'secondary' },
};

const useStyles = makeStyles(theme => ({
  table: {
    tableLayout: 'fixed',
  },
  tableCell: {
    padding: theme.spacing(1),
    fontWeight: 'bold',
    borderBottom: 'none',
    '&:first-child': {
      paddingLeft: theme.spacing(2),
    },
    '&:last-child': {
      paddingRight: theme.spacing(2),
    },
  },
}));

const PayeoffCell = ({ finance }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const handleEdite = () => {
    dispatch(setCurrentPayoff(finance));
    history.push('manage-payeoff');
  };

  return (
    <>
      <Table className={classes.table}>
        <TableBody>
          {/* Content Rows */}
          <TableRow>
            <TableCell className={classes.tableCellRoot}>{finance.user.fullname}</TableCell>
            <TableCell className={classes.tableCellRoot}>
              {finance.state ? (
                <Chip label={stateMap[finance.state]?.label} size="small" color={stateMap[finance.state]?.color} />
              ) : null}
            </TableCell>
            <TableCell className={classes.tableCellRoot}>{finance.user.mobile}</TableCell>
            <TableCell className={classes.tableCellRoot}>{toPersianMoneyForamt(finance.amount)} تومان</TableCell>
            <TableCell className={classes.tableCellRoot}>{toPersianDate(finance.created_at)}</TableCell>
            <TableCell className={classes.tableCellRoot} style={{ textAlign: 'end' }}>
              <Tooltip title="ویرایش">
                <IconButton size="small" target="_blank" onClick={() => handleEdite()}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

PayeoffCell.propTypes = {
  finance: PropTypes.object.isRequired,
};

export default PayeoffCell;
